/* TrackBricks — page Panier : quantites et suppression */
(function () {
  'use strict';

  function update(key, quantity) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [key]: quantity } })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      })
      .then(function () { window.location.reload(); })
      .catch(function (err) {
        console.error('[tbCart]', err);
        window.location.reload();
      });
  }

  window.tbCart = {
    update: update,
    changeQty: function (btn, delta) {
      var wrapper = btn.closest('.tb-cart__qty');
      var input = wrapper.querySelector('.tb-cart__qty-input');
      var newQty = Math.max(0, parseInt(input.value, 10) + delta);
      input.value = newQty;
      update(input.getAttribute('data-key'), newQty);
    },
    remove: function (btn) {
      update(btn.getAttribute('data-key'), 0);
    }
  };
})();